import React, {useMemo} from "react";
import {Chart} from "react-chartjs-2";

export const KPIChart = ({
    kpi,
    binSizeDays
}) => {
    const chartOptions = useMemo(() => {
        return kpi.chart({binSizeDays});
    }, [binSizeDays, kpi]);

    if (!chartOptions) {
        return <div className={"kpi-chart-loading"}>Loading...</div>;
    }

    return <Chart
        {...chartOptions}
        key={"chart-js-" + kpi.chartKey()}
        redraw={true}
    />
};